
<div class="form-group form-group-sm" *ngIf="schema">
  <schema-label
      #labelComponent
      [label]="label"
      [schema]="schema"
      [hidden]="schema.hidden"
      [refBase]="refBase"
      [expand]="value !== undefined || depth > 0"
      [required]="required"
      [showExpand]="true"
      [showRemove]="showRemove"
      (onRemoved)="valueChange.emit(undefined)"
      (expandChange)="setDefaultValue()"
      (schemaChange)="setSchema($event)"
      (typeChange)="setDefaultValue(); setParameter()"
      (subtypeChange)="setSubschema($event)">
  </schema-label>
  <div *ngIf="labelComponent.expand">
    <div *ngIf="labelComponent.type === 'string' || labelComponent.type === 'number' || labelComponent.type === 'integer' || labelComponent.type === 'boolean'">
      <parameter *ngIf="parameter" [parameter]="parameter"
            [model]="parameterModel"
            [readOnly]="readOnly"
            [hideLabel]="true" [view]="'console'"
            [fillFromSecrets]="schema.fromSecrets"
            (valueChange)="value = $event; valueChange.emit(value)"></parameter>
    </div>
    <div *ngIf="value !== undefined">
      <div class="nested-editor" *ngIf="labelComponent.type === 'object'">
        <json-schema-form
               *ngFor="let prop of allProperties"
               [label]="prop"
               [nested]="true"
               [depth]="depth - 1"
               [readOnly]="prop === schema.discriminator"
               [required]="(schema.required || []).indexOf(prop) !== -1"
               [schema]="util.getPropertySchema(prop, schema, refBase) || util.getPropertySchema(prop, subschema, refBase) || util.getSchemaFromValue(value[prop])"
               [showRemove]="removableProperties.indexOf(prop) !== -1"
               [refBase]="refBase"
               [value]="value[prop]"
               (valueChange)="nestedValueChange(prop, $event)">
        </json-schema-form>
        <div class="input-group input-group-sm" *ngIf="schema.additionalProperties || (allProperties.length === removableProperties.length && !schema['x-abstract'])">
          <input class="form-control" placeholder="Add a field" [(ngModel)]="additionalPropertyName" (keyup)="$event.keyCode === 13 ? addProperty() : null">
          <div class="input-group-btn">
            <button class="btn btn-default dropdown-toggle" data-toggle="dropdown">
              <span>{{additionalPropertyType || 'Type'}}</span>
              <i class="fa fa-right fa-caret-down"></i>
            </button>
            <ul class="dropdown-menu">
              <li *ngFor="let schemaType of util.SCHEMA_TYPES" [hidden]="schemaType === 'array'">
                <a (click)="additionalPropertyType = schemaType">{{schemaType}}</a>
              </li>
            </ul>
            <a class="btn btn-default" (click)="addProperty()">Add</a>
          </div>
        </div>
      </div>
      <div class="nested-editor" *ngIf="labelComponent.type === 'array'">
        <json-schema-form
               *ngFor="let val of util.range(numItems || 0); let valIdx = index;"
               [label]="label + '[' + valIdx + ']'"
               [nested]="true"
               [schema]="schema.items"
               [depth]="1"
               [refBase]="refBase"
               [showRemove]="true"
               [value]="value[valIdx]"
               (valueChange)="nestedValueChange(valIdx, $event);">
        </json-schema-form>
        <div class="btn-toolbar">
          <a class="btn btn-sm btn-default" (click)="numItems = numItems + 1">Add item</a>
        </div>
      </div>
    </div>
  </div>
</div>
    


// WEBPACK FOOTER //
// ./src/app/json-schema-form/json-schema-form.component.ts.JSONSchemaFormComponent.html